<template>
<div>
    <div class="row justify-content-center" v-if="componentState === 'index'">
        <!-- index interface -->
        <div class="col-md-8">
            <div class="card">
                <div class="card-body">
                    <a-form :form="form">
                      <div class="row">
                          <div class="col-md-6">
                              <a-form-item label="Select Report Type">
                                  <a-select default-value="0" @change="handleReportType">
                                    <a-select-option value="0">Select</a-select-option>
                                    <a-select-option value="1">Products Stocks List</a-select-option>
                                    <a-select-option value="2">Orders</a-select-option>
                                  </a-select>
                              </a-form-item>
                          </div>
                          <div class="col-md-3" v-if="selectedValue == '1'">
                            <a-form-item label="Min. Quantity"  >
                              <a-input-number v-model="minQuantity" :disabled="isOutOfStock" ></a-input-number>
                            </a-form-item>
                          </div>
                          <div class="col-md-3" v-if="selectedValue == '1'">
                            <a-form-item label="Out of Stock" >
                              <a-checkbox v-model="isOutOfStock"></a-checkbox>
                            </a-form-item>
                          </div>
                          <div class="col-md-3" v-if="selectedValue == '2'">
                            <a-form-item label="Start Date" >
                              <a-date-picker
                                v-model="start_date"
                                v-decorator="['start_date', {rules: [{ required: true, message: 'Please input a start date' }], initialValue: moment()},]"
                              />
                            </a-form-item>
                          </div>
                          <div class="col-md-3" v-if="selectedValue == '2'">
                            <a-form-item label="End Date" >
                              <a-date-picker
                                v-model="end_date"
                                v-decorator="['end_date',{rules: [{ required: false, message: 'Please input an end date' }]},]"
                              />
                            </a-form-item>
                          </div>
                      </div>
                      <div class="row">
                        <a-divider style="margin:15px 0px 5px 0px;"/>
                        <div class="col-md-12" style="text-align: center; padding:15px 0px;">
<!--                                    <a-button type="primary" @click="handleReport" :disabled="btnState.viewFrozen">View Report</a-button>&nbsp;-->
                                    <a-button icon="download" @click="handleDownload" :disabled="disablebtn">Download Report</a-button>
                        </div>
                      </div>
                    </a-form>
                </div>
            </div>
        </div>
        <!-- end index interface -->
    </div>
</div>

</template>

<script>
import moment from 'moment'
// import dailyReport from '@/components/StaffAttendance/dailyreport'

const PRODUCT_STOCKS_LIST_API_URI = '/api/inventory/report/product/stocks/export'
const PRODUCT_ORDERS_EXPORT_API_URI = '/api/inventory/order/export'

export default {
  name: 'InventoryReports',
  //   components: { dailyReport },
  data: function() {
    return {
      form: this.$form.createForm(this, { name: 'attendanceindex' }),
      date: moment(),
      disablebtn: false,
      bodydata: {
        url: PRODUCT_STOCKS_LIST_API_URI,
        reportType: 'productStockList',
      },
      componentState: 'index',
      // ifdaily: true,
      selectedValue: '0',
      minQuantity: null,
      isOutOfStock: false,
      btnState: { viewFrozen: true, downloadFrozen: true },
      start_date: null,
      end_date: null,
    }
  },
  watch: {
    date: function(n, o) {
      console.log('this.date', n)
      if (n === null) {
        this.btnState.viewFrozen = true
      } else {
        this.btnState.viewFrozen = false
      }
    },
  },
  methods: {
    moment,
    /* handleReport: function() {
      if (this.bodydata.reportType === 'daily') {
        console.log(moment(this.data).format('YYYY-MM-DD'))
        this.$router.push({ name: 'dailyattendancereport', params: { day: moment(this.date).format('YYYY-MM-DD') } })
      } else {
        console.log(moment(this.data).format('YYYY-MM'))
        this.$router.push({ name: 'monthlyattendancereport', params: { month: moment(this.date).format('YYYY-MM') } })
      }
      // this.$router.push({ name: 'monthlyattendancereport', params: { month: '07' }})
    }, */
    handleReportType: function(value) {
      if (value === '1') {
        this.bodydata = {
          url: PRODUCT_STOCKS_LIST_API_URI,
          reportType: 'productStocksList',
        }
      } else if (value === '2') {
        this.bodydata = {
          url: PRODUCT_ORDERS_EXPORT_API_URI,
          reportType: 'productOrders',
        }
      } else {
        this.selectedValue = value
      }
      this.selectedValue = value
      // change url and prepare readydata
    },
    onChange: function(date, datestring) {
      // console.log(datestring)
      this.date = datestring
      console.log(this.date)
    },
    handleDownload: function () {
      this.disablebtn = true
      if (this.date != null) {
        var readydata = {}
        var filename = ''
        if (this.bodydata.reportType === 'productStocksList') {
          readydata = {
            minQuantity: this.minQuantity,
            isOutOfStock: this.isOutOfStock,
          }
          filename = 'Product_Stocks_'
        } else if (this.bodydata.reportType === 'productOrders') {
          readydata = {
            start_date: moment(this.start_date).format('YYYY-MM-DD'),
            end_date: this.end_date ? moment(this.end_date).format('YYYY-MM-DD') : null,
          }
          filename = 'Orders_report_'
        }
        const header = {
          headers: {
            'Content-Type': 'application/jsons',
            Accept: 'application/json',
          },
          responseType: 'blob',
        }

        this.$http.post(this.bodydata.url, readydata, header)
          .then((res) => {
            var FILE = window.URL.createObjectURL(new Blob([res.data])) // new Blob([res.data], { type: 'application/json' }) // window.URL.createObjectURL(new Blob([res.data]))
            var docURL = document.createElement('a')
            docURL.href = FILE
            docURL.setAttribute('download', `${filename}${this.moment(this.date).format('YYYY-MM-DD HH:mm:ss')}.xlsx`)
            document.body.appendChild(docURL)
            docURL.click()
            this.disablebtn = false
          })
          .catch((err) => {
            console.log(err)
            this.disablebtn = false
          })
      }
    },
  },
}
</script>

<style>

</style>
